import styled from 'styled-components'

const StyledLessonResourceList = styled.div`
  padding: 25px 0;
  display: grid;
  gap: 20px;
`

export default StyledLessonResourceList
